import { useEffect } from "react";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { useDispatch } from "src/store";
import { thunks as settingsThunks } from "src/thunks/settings";
import { useParams } from "react-router";
import type { Page as PageType } from "src/types/page";
import { thunks } from "src/thunks/strategy-wizard";
import { thunks as strategyThunks } from "src/thunks/strategy-wizard";
import { useStrategySteps } from "./use-strategy-steps";
import { TargetAudience } from "src/sections/strategy/target-audience";
import { slice as strategyWizardSlice } from "src/slices/strategy-wizard";
const Page: PageType = () => {
  usePageView();
  const router = useRouter();
  const dispatch = useDispatch();

  const { strategyId } = useParams();

  const configSteps = useStrategySteps();

  useEffect(() => {
    async function initSteps() {
      if (strategyId) {
        await dispatch(strategyThunks.setCurrentStep(1));
        await dispatch(thunks.getStrategySteps(configSteps));
        await dispatch(settingsThunks.setStrategyId(strategyId));
        dispatch(
          strategyWizardSlice.actions.setSectionValue({
            items: [""],
          })
        );
      } else {
        router.push(paths.index);
      }
    }
    initSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategyId]);

  if (!configSteps.length) {
    return null;
  }

  return (
    <>
      <Seo title="Who is your target audience?" />
      {strategyId && configSteps && <TargetAudience />}
    </>
  );
};

export default Page;
